import { createContext, useContext } from 'react';
import { BaseOption } from 'ui/selectv2/types';
import noop from 'utils/noop';

import { AnonUserCriteriaSettings } from './types';

export interface CriteriaRetentionContextState {
  // Takeover
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;

  // Data
  anonUserCriteriaSettings: AnonUserCriteriaSettings | null;
  hasCriteriaSettingsError: boolean;
  isLoadingSettings: boolean;

  // State
  isRetentionEnabled: boolean;
  setIsRetentionEnabled: (enabled: boolean) => void;
  excludedListIds: number[];
  selectedListOptions: BaseOption[];
  setSelectedListOptions: (options: BaseOption[]) => void;
  selectedRetentionOption: string;

  // Handlers
  handleSelect: (value: string) => void;
  handleListSelection: (options: BaseOption[]) => void;

  // List data
  listOptions: BaseOption[];
  isLoadingLists: boolean;
  hasListsError: boolean;
  listsErrorMessage: any;

  // Save function
  handleSave: () => void;

  // Refetch function
  refetchCriteriaSettings: () => void;
}

const DEFAULT_CRITERIA_RETENTION_CONTEXT_STATE: CriteriaRetentionContextState = {
  isOpen: false,
  setIsOpen: noop,
  anonUserCriteriaSettings: null,
  hasCriteriaSettingsError: false,
  isLoadingSettings: false,
  isRetentionEnabled: false,
  setIsRetentionEnabled: noop,
  excludedListIds: [],
  selectedListOptions: [],
  setSelectedListOptions: noop,
  selectedRetentionOption: '7',
  handleSelect: noop,
  handleListSelection: noop,
  listOptions: [],
  isLoadingLists: false,
  hasListsError: false,
  listsErrorMessage: null,
  handleSave: noop,
  refetchCriteriaSettings: noop,
};

export const CriteriaRetentionContext = createContext<CriteriaRetentionContextState>(
  DEFAULT_CRITERIA_RETENTION_CONTEXT_STATE,
);
export const useCriteriaRetentionContext = () => useContext(CriteriaRetentionContext);
